export default __webpack_public_path__ + "static/media/ChillHopMusic-LofiHipHop.5accf15f.png";